import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import CustomButton from '../motifComponents/button/CustomButton';
import { useDispatch, useSelector } from 'react-redux';
import {
  chatSearchInputValue,
  setRightSideBarOpenClose,
  setSideBarOpenClose
} from '../../store/actions/commonActions';
import { lastExecutedMessage, setAnySourceSelected } from '../../store/actions/userChatActions';
import { IStore } from '../../store';
import { buttonImg, dataServerImg, deepResearchImg } from '../../commonImage';
import { RESPONSE_BY } from '../../models/IQueryType';
import { setChatHistory, toggleLoader } from '../../store/actions/userChatActions';
type ISearchContainerProps = {
  getInputData?: (val: string) => void;
};
const SearchContainer = ({ getInputData }: ISearchContainerProps): JSX.Element => {
  const dispatch = useDispatch();
  const isSidebarOpen = useSelector((state: IStore) => state.common.isSideBarOpen);
  const textFieldValue = useSelector((state: IStore) => state?.common?.chatSearchInput);
  const isTextFieldEmpty = textFieldValue !== undefined && textFieldValue.length > 0;
  const anySourceSelected = useSelector((state: IStore) => state?.common?.anySourceSelected);
  const selectedDataSourceSection = useSelector(
    (state: any) => state.userChat.selectedDataSourceSection
  );
  const [isSourceSelected, setSourceSelected] = useState(!anySourceSelected);
  const [isFocused, setIsFocused] = useState(isSidebarOpen);
  const history = useNavigate();
  const [chatSearchInput, setChatSearchInputValue] = useState('');
  const [inputValuelength, setInputValueLength] = useState('');
  const { isClearLoading, isLoading } = useSelector((state: any) => state.userChat);
  const selectedChatThread = useSelector((store: IStore) => store.userChat.selectedChatThread);
  const selectedCheckboxes: string[] =
    useSelector((state: IStore) => state.common.checkedCheckboxes) ?? [];
  const lastQuery = useSelector((store: IStore) => store.userChat.lastQuery);

  dispatch(chatSearchInputValue(chatSearchInput));
  const refToScroll = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setSourceSelected(anySourceSelected || true);
  }, [anySourceSelected]);

  useEffect(() => {
    setIsFocused(isSidebarOpen);
  }, [isSidebarOpen]);

  useEffect(() => {
    setChatSearchInputValue(lastQuery);
  }, []);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    if (newValue.length <= 1000) {
      setInputValueLength(newValue);
    }
    setChatSearchInputValue(newValue);
  };

  const handleKeyDown = (ev: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (ev.key === 'Enter') {
      ev.preventDefault();
      handleSendMessage();
    }
  };

  const handleCombinedCheckbox = () => {
    const hasMarket = selectedCheckboxes.includes('Market reports');
    const hasOpenAI = selectedCheckboxes.includes('Open AI');
    const hasEmbryonic = selectedCheckboxes.includes('Embryonic');

    if (hasMarket) {
      // Any combination including Market reports
      if (!hasOpenAI && !hasEmbryonic) {
        history('/marketReports');
      } else {
        history('/with-marketReports');
      }
    } else if (hasOpenAI || hasEmbryonic) {
      // Any combination of Open AI and/or Embryonic (without Market reports)
      history('/publicChatPage');
    } else {
      // No source selected
      history('/');
    }
  };

  const handleSendMessage = (query?: string) => {
    if (!isClearLoading && !isLoading && anySourceSelected && selectedDataSourceSection !== 4) {
      dispatch(setAnySourceSelected(true));
      const safeQuery = typeof query === 'string' && query.trim().length ? query : chatSearchInput;
      dispatch(lastExecutedMessage(safeQuery));
      setSourceSelected(true);
      getInputData?.(chatSearchInput || '');
      
      if ((chatSearchInput && chatSearchInput.trim().length) || query) {
        let newMsg = {
          [RESPONSE_BY.USER]: {
            summary: safeQuery
          }
        };
        dispatch(setChatHistory([newMsg]));
        refToScroll?.current?.scrollIntoView({
          behavior: 'smooth',
          block: 'end'
        });

        setChatSearchInputValue('');
        dispatch(toggleLoader(true));
        handleCombinedCheckbox();
        if (Object.keys(selectedChatThread).length === 0 && !localStorage.isSidebarManuallyClosed) {
          dispatch(setRightSideBarOpenClose(true));
        }
      }
    } else if (
      !isClearLoading &&
      !isLoading &&
      anySourceSelected &&
      selectedDataSourceSection === 4
    ) {
      dispatch(setAnySourceSelected(true));
      setSourceSelected(true);
      getInputData?.(chatSearchInput || '');
      if ((chatSearchInput && chatSearchInput.trim().length) || query) {
        let newMsg = {
          [RESPONSE_BY.USER]: {
            summary: chatSearchInput || query
          }
        };
        dispatch(setChatHistory([newMsg]));
        refToScroll?.current?.scrollIntoView({
          behavior: 'smooth',
          block: 'end'
        });

        setChatSearchInputValue('');
        dispatch(toggleLoader(true));
        history('/uploadURLPage');
        dispatch(setRightSideBarOpenClose(true));
      }
    } else {
      dispatch(setAnySourceSelected(false));
      setSourceSelected(false);
    }
  };

  const handleFocus = (event: React.FocusEvent<HTMLInputElement>) => {
    event.target.placeholder = '';
    if (!isFocused) {
      dispatch(setSideBarOpenClose(true));
      setIsFocused(true);
    }
  };

  const handleOnBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    event.target.placeholder = 'What would you like to ask?';
    setIsFocused(false);
  };

  const handleSelectSource = () => {
    dispatch(setSideBarOpenClose(!isSidebarOpen));
  };
  
  const handlerDeepResearch = ()=>{
    history('/deepResearch')
    dispatch(setRightSideBarOpenClose(true));
    dispatch(setSideBarOpenClose(false))
  }

  return (
    <StyleSearchBar isSourceSelected={isSourceSelected}>
      <div className='outer-border'>
        <div className='search-bar'>
          <div className='input-container'>
            <input
              type='text'
              value={chatSearchInput}
              onChange={handleInputChange}
              className='input-bar'
              placeholder='What would you like to ask?'
              onFocus={handleFocus}
              onBlur={handleOnBlur}
              maxLength={1000}
              onKeyDown={(event: any) => handleKeyDown(event)}
            />
            <div className='warning-length'>
              {isFocused && isSourceSelected && (
                <div className='messgeText'>{'Select a data source to submit your question'} </div>
              )}
              {!isSourceSelected && (
                <div className='warning'>
                  {selectedDataSourceSection === 4
                    ? 'Please upload a URL to continue'
                    : 'Please select a data source to continue'}
                </div>
              )}
              <span className='number-validate'>{`(${inputValuelength.length ?? 0}/1000)`}</span>
            </div>
            <div className='button-container'>
              <CustomButton onClickHandler={handleSelectSource} customSedButton={`select-source-button ${isSidebarOpen ? "select-source-button-active" : ""}`}>
                <img src={dataServerImg} alt='select source' /> Select Source
              </CustomButton>
              {/* <CustomButton onClickHandler={handlerDeepResearch} customSedButton='deep-research-button'>
                <img src={deepResearchImg} alt='deep research' /> Deep Research
              </CustomButton> */}
            </div>
          </div>
          <span>
            <CustomButton disabled={!isTextFieldEmpty} onClickHandler={handleSendMessage} customSedButton='search-button home-search-btn'>
              <img src={buttonImg} alt='search button' />
            </CustomButton>
          </span>
        </div>
      </div>
    </StyleSearchBar>
  );
};

const StyleSearchBar = styled.div<{
  isSourceSelected?: boolean;
}>`
  display: flex;
  justify-content: center;

  .outer-border {
    border: 1px solid #c3c3cb;
    height: 130px;
    width: 85%;
    border-radius: 11px;
  }
  .search-bar {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    background: #f6f6fa;
    border-radius: 11px;
  }
  .input-bar {
    width: 100%;
    height: 44px;
    border-radius: 5px;
    border: 1px solid #c3c3cb;
    padding-left: 10px;
  }
  .warning {
    color: red;
    font-size: 12px;
    width: 100%;
  }
  .messgeText {
    font-size: 12px;
    width: 100%;
  }
  .warning-length {
    display: flex;
    color: #747480;
  }
  .number-validate {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    font-size: 12px;
    font-weight: 400;
    position: relative;
    top: 0px;
  }
  .input-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    top: ${(props) => (props.isSourceSelected ? '12px' : '11px')};
    margin-left: 37px;
  }
  .button-container{
    display: flex;
  }
  .select-source-button{
    width: 146px;
    height: 36px;
    opacity: 1;
    gap: 8px;
    border-radius: 4px;
    padding-top: 8px;
    padding-right: 14px;
    padding-bottom: 8px;
    padding-left: 14px;
    background-color:#DEDEE2;
    color:#3F3F4C;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0px;
    border: none;
  }
  .deep-research-button{
    border: none;
    width: 153px;
    height: 36px;
    opacity: 1;
    gap: 8px;
    border-radius: 4px;
    padding-top: 8px;
    padding-right: 14px;
    padding-bottom: 8px;
    padding-left: 14px;
    background-color:#DEDEE2;
    color:#3F3F4C;
    font-size: 14px;
    line-height: 20px;
    white-space: nowrap;
    letter-spacing: 0px;
    left: 15px;
  }
  .select-source-button:hover, .deep-research-button:hover {
    background-color: #ccc;;
    color: white;
  } 
  .select-source-button-active{
    background-color: #D8E5FD;
  }
  .home-search-btn{
    bottom: 27px;
  }
`;

export default SearchContainer;
